import React from "react";

import NumberInput from "@cayuse/shared-react.components.form.inputs.number";

import ErrorInput from "components/ErrorInput";
import { useDictionary } from "hooks/useDictionary";
import { getEffortError } from "utils/budgetBuilder";


export const EffortInput = props => {
	const dictionary = useDictionary("budgetBuilder.components.EffortInput");
	const validateEffort = newEffort => {
		const effortError = getEffortError(newEffort);

		return effortError ? dictionary?.[effortError] : null;
	};


	return (
		<ErrorInput
			{...props}
			validate={validateEffort}
			renderInput={inputProps => <NumberInput {...inputProps} />}
		/>
	);
};
